module.exports = __webpack_public_path__ + "static/media/gal-8.7762b905.jpeg";